import Icon from '../components/Icon.vue'

Icon.register({
  'paint-brush': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M167 309.3C126.9 311.9 90.5 327.2 69.8 381.6 67.5 387.9 61.8 391.6 55.2 391.6 44.1 391.6 9.8 363.9 0 357.3 0 439.6 37.9 512 128 512 203.9 512 256 468.2 256 391.8 256 388.7 255.3 385.7 255 382.7L167 309.3zM457.9 0C442.7 0 428.5 6.7 417.7 16.4 213.3 199.1 192 203.3 192 257.1 192 270.8 195.3 283.9 200.7 295.8L264.6 349C271.8 350.8 279.2 352 286.9 352 349.1 352 385.1 306.5 498.1 95.5 505.5 81.2 512 65.7 512 49.5 512 20.6 486 0 457.9 0z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/paint-brush.js
// module id = Asdg
// module chunks = 144